import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteNoteComponent } from '../pop-up/delete-note/delete-note.component';
import { SignatureService } from '@services/signature.service';
import { ToastService } from '../toast/toast-service';

@Component({
    selector: 'signature-detail',
    templateUrl: './signature-detail.html',
    styleUrls: ['./signature-detail.scss'],
    standalone: false
})
export class SignatureDetail implements OnInit {
@Input() signatures;
@Input() path;
@Input() isNote: boolean = false;
@Output() deleteNoteEmit = new EventEmitter<boolean>();
@Output() editNoteEmit = new EventEmitter<number>();

  remindingIds = new Set<string>();

  constructor(
    private modalService: NgbModal,
    private signatureService: SignatureService,
    private toastService: ToastService,
  ) { }

  ngOnInit() {
  }

  hasPendingSigners(data: any): boolean {
    const signers = this.getSigners(data);
    return signers.some(signer => !this.isSignerComplete(signer));
  }

  canSendReminder(data: any): boolean {
    return !!data?.signatureId && this.hasPendingSigners(data);
  }

  isReminding(signatureId: string): boolean {
    return this.remindingIds.has(signatureId);
  }

  sendReminder(data: any): void {
    const signatureId = data?.signatureId;
    if (!signatureId || this.isReminding(signatureId)) {
      return;
    }

    this.remindingIds.add(signatureId);
    this.signatureService.sendReminder(signatureId).subscribe({
      next: (response: any) => {
        const data = response?.result ?? response;
        const message = data?.message || 'Recordatorio enviado a los firmantes pendientes';
        this.toastService.show(message, { classname: 'bg-success text-light', delay: 4000 });
        this.remindingIds.delete(signatureId);
      },
      error: (err) => {
        const message = err?.error?.message || err?.error?.result?.message || err?.message || 'No se pudo enviar el recordatorio';
        this.toastService.show(message, { classname: 'bg-danger text-light', delay: 5000 });
        this.remindingIds.delete(signatureId);
      },
    });
  }

  private getSigners(data: any): any[] {
    if (data?.firmantes?.length) {
      return data.firmantes;
    }
    if (data?.fields?.length) {
      return data.fields;
    }
    return [];
  }

  private isSignerComplete(signer: any): boolean {
    return !!(signer?.ready || signer?.signStatus);
  }

	/* Delete a Note*/
	deleteNote(id: number) {
		const modalRef = this.modalService.open(DeleteNoteComponent, {
			size: 'md', backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.idFile = id;
		modalRef.componentInstance.path = this.path;
		modalRef.componentInstance.title = 'Nota';
		modalRef.componentInstance.deleteFile.subscribe(deleteFile => {
			if (deleteFile) {
				setTimeout(() => this.deleteNoteEmit.emit(deleteFile), 1000);
			}
		});
	}
}
